import * as React from 'react';

import {
  ActionContainer,
  Container,
  Details,
  DetailsContainer,
  Heading,
  IconContainer,
  NotificationWrapper,
} from './top-service-mode-notification.styled';
import { ITopServiceModeNotificationViewProps } from './types';

export const TopServiceModeNotificationView = React.forwardRef<
  HTMLDivElement,
  ITopServiceModeNotificationViewProps
>(({ heading, icon, details, cta, className = '' }, ref) => {
  return (
    <Container ref={ref} className={className}>
      <NotificationWrapper>
        <IconContainer data-testid="service-notification-icon">{icon}</IconContainer>
        <DetailsContainer>
          {heading && <Heading data-testid="service-notification-heading">{heading}</Heading>}
          {details && <Details data-testid="service-notification-details">{details}</Details>}
        </DetailsContainer>
        <ActionContainer>{cta}</ActionContainer>
      </NotificationWrapper>
    </Container>
  );
});
